import type { ElementType, ReactNode } from 'react'
import { cn } from '@/utils/cn'
import { PAGE_TOOLBAR, tabClass } from './pageToolbarStyles'

export interface SegmentTab<T extends string = string> {
  id: T
  label: ReactNode
  /** Rótulo curto em telas lg (opcional) */
  shortLabel?: ReactNode
  icon?: ElementType
  title?: string
}

interface SegmentTabsProps<T extends string> {
  tabs: SegmentTab<T>[]
  value: T
  onChange: (id: T) => void
  ariaLabel?: string
  className?: string
}

export function SegmentTabs<T extends string>({
  tabs,
  value,
  onChange,
  ariaLabel = 'Abas da página',
  className,
}: SegmentTabsProps<T>) {
  return (
    <div
      className={cn(PAGE_TOOLBAR.tabList, className)}
      role='tablist'
      aria-label={ariaLabel}
    >
      {tabs.map((tab) => {
        const isActive = value === tab.id
        const Icon = tab.icon
        return (
          <button
            key={tab.id}
            type='button'
            role='tab'
            aria-selected={isActive}
            title={tab.title ?? (typeof tab.label === 'string' ? tab.label : undefined)}
            onClick={() => onChange(tab.id)}
            className={tabClass(isActive)}
          >
            {Icon && <Icon size={14} aria-hidden />}
            {tab.shortLabel != null ? (
              <>
                <span className='hidden lg:inline xl:hidden'>{tab.shortLabel}</span>
                <span className='hidden xl:inline'>{tab.label}</span>
              </>
            ) : (
              <span>{tab.label}</span>
            )}
          </button>
        )
      })}
    </div>
  )
}
